// ACC
const BOOKING_RECORD_STATUS = {
    "PENDING": 0,
    "CONFIRMED": 1,
    "PAYING": 2,
    "CANCELLED_BY_USER": -1,
    "CANCELLED_BY_ADMIN": -99,
    "EXPIRED": -2,
    "NO_SHOW": -3,
};

const BOOKING_RECORD_STATUS_LABEL = {
    "0": "booking_record_status.pending",
    "1": "booking_record_status.confirmed",
    "2": "booking_record_status.paying",
    "-1": "booking_record_status.cancelled_by_user",
    "-99": "booking_record_status.cancelled_by_admin",
    "-2": "booking_record_status.expired",
    "-3": "booking_record_status.no_show",
};

const BOOKING_STATUS = {
    "RESERVED": 0,
    "CONFIRMED": 1,
    "CANCELLED_BY_USER": -1,
    "REFUNDED": -99,
    "CANCELLED_BY_ADMIN": -99,
    "EXPIRED": -2,
    "NO_SHOW": -3,
    "CREATED_BY_ADMIN": 99,
};

const BOOKING_STATUS_LABEL = {
    "0": "booking_status.reserved",
    "1": "booking_status.confirmed",
    "2": "booking_status.paying",
    "-1": "booking_status.cancelled_by_user",
    "-98": "booking_status.refunded",
    "-99": "booking_status.cancelled_by_admin",
    "-2": "booking_status.expired",
    "-3": "booking_status.no_show",
    "99": "booking_status.created_by_admin",
};

export const PACKAGE_CONTENT_TYPE = {
    "POINT": "point",
    "COUPON": "coupon",
}

export const PACKAGE_CONTENT_TYPE_LABEL = {
    "point": "package_content_type.point",
    "coupon": "package_content_type.coupon",
}

export const PAYMENT_METHOD = {
    CYBER_SOURCE: 'cyber_source',
    UNION_PAY: 'union_pay',
    POINT: 'point',
}

export const CYBER_SOURCE_PAYMENT_DECISION = {
    ACCEPT: 'ACCEPT',
    DECLINE: 'DECLINE',
    NOT_FOUND: 'NOT_FOUND',
    REFUND: 'REFUND',
}

export const DISCOUNT_CODE_TYPE = {
    FACILITY: 'FACILITY',
    GYM_PASS: 'GYM_PASS',
    MEMBERSHIP: 'MEMBERSHIP',
}

export {BOOKING_RECORD_STATUS, BOOKING_RECORD_STATUS_LABEL, BOOKING_STATUS, BOOKING_STATUS_LABEL}
